import { Component, Inject, inject, effect } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { AgrEnvironment, EnvironmentInjector } from '@next/core-lib/environment';
import { LocaleService } from '@next/core-lib/i18n';
import { SiteActions, SiteSelectors } from '@next/core-lib/site';
import { Store } from '@ngrx/store';

import { DevAuthRequest } from './models/dev-auth-request.model';
import { sendAuthenticatedRequest } from './store/actions/dev-auth-actions';
import { getDevAuthResponse } from './store/selectors/dev-auth.selectors';
import { SiteState } from '../shared/models/siteState.model';

@Component({
  selector: 'app-auth',
  templateUrl: './dev-auth.component.html',
  standalone: false,
})
export class DevAuthComponent {
  private readonly store = inject(Store<SiteState>);
  private readonly route = inject(ActivatedRoute);
  private readonly locale = inject(LocaleService);

  pageTitle = toSignal(this.store.select(SiteSelectors.selectPageTitle));
  response = toSignal(this.store.select(getDevAuthResponse));
  devAuthrequest: DevAuthRequest = {
    requestURL: this.env.API_BASE_URL + '/service/authorization/secure/access/application',
    requestType: 'get',
    requestBody: '{}',
  };

  constructor(@Inject(EnvironmentInjector) private env: AgrEnvironment) {
    effect(() => {
      const titleKey = this.route.snapshot.data['pageTitle'];
      if (titleKey) {
        this.store.dispatch(
          SiteActions.updatePageTitle({ pageTitle: this.locale.translate(titleKey) }),
        );
      }
    });
  }

  makeRequest() {
    this.store.dispatch(sendAuthenticatedRequest(this.devAuthrequest));
  }
}
